import { cn } from "@/lib/utils"
import "./LoadingDots.css"

interface LoadingProps {
  className?: string
  color?: string
  size?: "small" | "medium" | "large"
}

export default function Loading({
  className,
  color = "bg-primary", // More professional gray default
  size = "medium",
}: LoadingProps) {
  const sizeClasses = {
    small: "h-1.5 w-1.5 mx-0.5",
    medium: "h-2 w-2 mx-1",
    large: "h-2.5 w-2.5 mx-1.5",
  }

  return (
    <div className={cn("flex items-center justify-center", className)} aria-label="Loading" role="status">
      {[0, 1, 2].map((i) => (
        <div key={i} className="relative">
          <div
            className={cn("rounded-full", sizeClasses[size], color)}
            style={{
              animation: "bounce 1s infinite",
              animationDelay: `${i * 0.15}s`,
              animationTimingFunction: "ease-in-out",
            }}
          />
          {/* Shadow underneath - more subtle */}
          <div
            className={cn("absolute bottom-0 left-1/2 -translate-x-1/2 rounded-full bg-black/5 blur-[1px]", {
              "w-1 h-[1px]": size === "small",
              "w-1.5 h-[1px]": size === "medium",
              "w-2 h-[1px]": size === "large",
            })}
            style={{
              animation: "shadow 1s infinite",
              animationDelay: `${i * 0.15}s`,
            }}
          />
        </div>
      ))}
    </div>
  )
}
